<p-dialog
  [(visible)]="showAccessRuleHelp"
  [modal]="true"
  [style]="{ width: '50vw' }"
  [baseZIndex]="10000"
  [draggable]="false"
  [resizable]="false"
>
  <ng-template pTemplate="header">
    <div class="dialog-header-title" i18n>Access Rule Presets</div>
  </ng-template>
  <div class="mb-3">Click on a preset number to apply the configuration to this elementary file.</div>
  <table width="100%" cellspacing="0" cellpadding="5" border="1">
    <tr style="background: var(--rs-gray-200)">
      <th style="width: 7rem" i18n>Preset</th>
      <th style="width: 7rem" i18n>Read</th>
      <th style="width: 7rem" i18n>Update</th>
      <th style="width: 7rem" i18n>Increase</th>
      <th style="width: 7rem" i18n>Activate</th>
      <th style="width: 7rem" i18n>Deactivate</th>
      <th style="width: 7rem" i18n>Delete</th>
    </tr>
    <tr>
      <td style="text-align: center">
        <ng-container *ngTemplateOutlet="applyAccessRulePresetButtonTemplate; context: { preset: 1 }"></ng-container>
      </td>
      <td style="text-align: center" i18n>ALWAYS</td>
      <td style="text-align: center" i18n>PIN1</td>
      <td style="text-align: center" i18n>NEVER</td>
      <td style="text-align: center" i18n>ADM1</td>
      <td style="text-align: center" i18n>ADM1</td>
      <td style="text-align: center" i18n>ADM1</td>
    </tr>
    <tr>
      <td style="text-align: center">
        <ng-container *ngTemplateOutlet="applyAccessRulePresetButtonTemplate; context: { preset: 2 }"></ng-container>
      </td>
      <td style="text-align: center" i18n>PIN1</td>
      <td style="text-align: center" i18n>ADM1</td>
      <td style="text-align: center" i18n>NEVER</td>
      <td style="text-align: center" i18n>ADM1</td>
      <td style="text-align: center" i18n>ADM1</td>
      <td style="text-align: center" i18n>ADM1</td>
    </tr>
    <tr>
      <td style="text-align: center">
        <ng-container *ngTemplateOutlet="applyAccessRulePresetButtonTemplate; context: { preset: 3 }"></ng-container>
      </td>
      <td style="text-align: center" i18n>ADM1</td>
      <td style="text-align: center" i18n>ADM1</td>
      <td style="text-align: center" i18n>NEVER</td>
      <td style="text-align: center" i18n>ADM1</td>
      <td style="text-align: center" i18n>ADM1</td>
      <td style="text-align: center" i18n>ADM1</td>
    </tr>
    <tr>
      <td style="text-align: center">
        <ng-container *ngTemplateOutlet="applyAccessRulePresetButtonTemplate; context: { preset: 4 }"></ng-container>
      </td>
      <td style="text-align: center" i18n>ALWAYS</td>
      <td style="text-align: center" i18n>NEVER</td>
      <td style="text-align: center" i18n>NEVER</td>
      <td style="text-align: center" i18n>NEVER</td>
      <td style="text-align: center" i18n>NEVER</td>
      <td style="text-align: center" i18n>ADM1</td>
    </tr>
    <tr>
      <td style="text-align: center">
        <ng-container *ngTemplateOutlet="applyAccessRulePresetButtonTemplate; context: { preset: 5 }"></ng-container>
      </td>
      <td style="text-align: center" i18n>PIN1</td>
      <td style="text-align: center" i18n>PIN1</td>
      <td style="text-align: center" i18n>NEVER</td>
      <td style="text-align: center" i18n>ADM1</td>
      <td style="text-align: center" i18n>ADM1</td>
      <td style="text-align: center" i18n>ADM1</td>
    </tr>
    <tr>
      <td style="text-align: center">
        <ng-container *ngTemplateOutlet="applyAccessRulePresetButtonTemplate; context: { preset: 6 }"></ng-container>
      </td>
      <td style="text-align: center" i18n>PIN1</td>
      <td style="text-align: center" i18n>ADM1</td>
      <td style="text-align: center" i18n>NEVER</td>
      <td style="text-align: center" i18n>PIN1</td>
      <td style="text-align: center" i18n>ADM1</td>
      <td style="text-align: center" i18n>ADM1</td>
    </tr>
    <tr>
      <td style="text-align: center">
        <ng-container *ngTemplateOutlet="applyAccessRulePresetButtonTemplate; context: { preset: 7 }"></ng-container>
      </td>
      <td style="text-align: center" i18n>PIN1</td>
      <td style="text-align: center" i18n>PIN1</td>
      <td style="text-align: center" i18n>PIN1</td>
      <td style="text-align: center" i18n>ADM1</td>
      <td style="text-align: center" i18n>ADM1</td>
      <td style="text-align: center" i18n>ADM1</td>
    </tr>
    <tr>
      <td style="text-align: center">
        <ng-container *ngTemplateOutlet="applyAccessRulePresetButtonTemplate; context: { preset: 8 }"></ng-container>
      </td>
      <td style="text-align: center" i18n>PIN1</td>
      <td style="text-align: center" i18n>PIN2</td>
      <td style="text-align: center" i18n>NEVER</td>
      <td style="text-align: center" i18n>ADM1</td>
      <td style="text-align: center" i18n>ADM1</td>
      <td style="text-align: center" i18n>ADM1</td>
    </tr>
    <tr>
      <td style="text-align: center">
        <ng-container *ngTemplateOutlet="applyAccessRulePresetButtonTemplate; context: { preset: 9 }"></ng-container>
      </td>
      <td style="text-align: center" i18n>ALWAYS</td>
      <td style="text-align: center" i18n>PIN1</td>
      <td style="text-align: center" i18n>NEVER</td>
      <td style="text-align: center" i18n>PIN1</td>
      <td style="text-align: center" i18n>PIN1</td>
      <td style="text-align: center" i18n>ADM1</td>
    </tr>
    <tr>
      <td style="text-align: center">
        <ng-container *ngTemplateOutlet="applyAccessRulePresetButtonTemplate; context: { preset: 10 }"></ng-container>
      </td>
      <td style="text-align: center" i18n>ALWAYS</td>
      <td style="text-align: center" i18n>ADM1</td>
      <td style="text-align: center" i18n>NEVER</td>
      <td style="text-align: center" i18n>ADM1</td>
      <td style="text-align: center" i18n>ADM1</td>
      <td style="text-align: center" i18n>ADM1</td>
    </tr>
    <tr>
      <td style="text-align: center">
        <ng-container *ngTemplateOutlet="applyAccessRulePresetButtonTemplate; context: { preset: 11 }"></ng-container>
      </td>
      <td style="text-align: center" i18n>ALWAYS</td>
      <td style="text-align: center" i18n>NEVER</td>
      <td style="text-align: center" i18n>NEVER</td>
      <td style="text-align: center" i18n>ADM1</td>
      <td style="text-align: center" i18n>ADM1</td>
      <td style="text-align: center" i18n>NEVER</td>
    </tr>
    <tr>
      <td style="text-align: center">
        <ng-container *ngTemplateOutlet="applyAccessRulePresetButtonTemplate; context: { preset: 12 }"></ng-container>
      </td>
      <td style="text-align: center" i18n>PIN1</td>
      <td style="text-align: center" i18n>NEVER</td>
      <td style="text-align: center" i18n>NEVER</td>
      <td style="text-align: center" i18n>NEVER</td>
      <td style="text-align: center" i18n>NEVER</td>
      <td style="text-align: center" i18n>NEVER</td>
    </tr>
    <tr>
      <td style="text-align: center">
        <ng-container *ngTemplateOutlet="applyAccessRulePresetButtonTemplate; context: { preset: 13 }"></ng-container>
      </td>
      <td style="text-align: center" i18n>PIN1</td>
      <td style="text-align: center" i18n>PIN1</td>
      <td style="text-align: center" i18n>NEVER</td>
      <td style="text-align: center" i18n>PIN1</td>
      <td style="text-align: center" i18n>ADM1</td>
      <td style="text-align: center" i18n>ADM1</td>
    </tr>
  </table>
  <ng-template pTemplate="footer">
    <p-button i18n-label label="Ok" (onClick)="showAccessRuleHelp = false"></p-button>
  </ng-template>
</p-dialog>
<p-dialog
  [(visible)]="displayCreateJavaAppletDialog"
  [modal]="true"
  [style]="{ width: '50vw' }"
  [baseZIndex]="10000"
  [draggable]="false"
  [resizable]="false"
>
  <ng-template pTemplate="header">
    <div class="dialog-header-title">
      <div i18n>Add Java Applet</div>
    </div>
  </ng-template>
  <div class="mb-3" i18n>Select a Java Applet from the list available within the Java Applet Warehouse to include in this profile.</div>
  <div class="mb-3">
    <p-select
      styleClass="maximize-inputs"
      [options]="selectableApplets"
      [(ngModel)]="selectedApplet"
      i18n-placeholder
      placeholder="Select applet:"
      optionLabel="label"
      appendTo="body"
    ></p-select>
  </div>
  <div class="p-inputgroup">
    <div class="p-field-checkbox">
      <span class="mr-2" i18n>Enter applet configuration after adding into profile:</span>
      <p-checkbox [(ngModel)]="editNewApplet" [binary]="true"></p-checkbox>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <p-button i18n-label label="Cancel" (onClick)="onCancelCreateJavaApplet()" [outlined]="true"></p-button>
    <p-button i18n-label label="Add" (onClick)="onCreateJavaApplet()" [disabled]="selectedApplet === null"></p-button>
  </ng-template>
</p-dialog>

<ng-container *ngIf="editAppletMode === false">
  <p class="font-bold line-height-2" i18n>
    Please select Java applets to include with this profile, if any are desired, from the list of applets managed by the Java Applet
    Warehouse.
  </p>
  <div class="mx-6">
    <rs-error-message *ngIf="errorFound" class="mb-3" [message]="errorMessage" />
    <p-table
      [value]="appletsDisplay"
      [(selection)]="selectedApplets"
      dataKey="appletId"
      sortField="appletId"
      [sortOrder]="1"
      styleClass="p-datatable-striped p-datatable-gridlines"
      showGridlines="true"
      stripedRows="true"
    >
      <ng-template pTemplate="caption">
        <div class="flex align-items-center gap-2">
          <p-button i18n-label label="Add" icon="pi pi-plus-circle" size="small" [outlined]="true" (onClick)="addApplet()"></p-button>
          <p-button
            i18n-label
            label="Delete"
            icon="pi pi-trash"
            size="small"
            severity="danger"
            [outlined]="true"
            (onClick)="deleteApplets()"
            [disabled]="!selectedApplets || !selectedApplets.length"
          ></p-button>
        </div>
      </ng-template>
      <ng-template pTemplate="colgroup">
        <colgroup>
          <col style="width: 3rem" />
          <col />
          <col />
          <col />
          <col style="width: 5rem" />
          <col style="width: 5rem" />
          <col style="width: 5rem" />
        </colgroup>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th>
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
          <th i18n>Name</th>
          <th i18n>Description</th>
          <th i18n>File Name</th>
          <th i18n>eSim Configuration</th>
          <th i18n>Warehouse Configuration</th>
          <th i18n>Actions</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-applet>
        <tr>
          <td style="text-align: center">
            <p-tableCheckbox [value]="applet"></p-tableCheckbox>
          </td>
          <td style="text-align: center">
            {{ applet.name }}
          </td>
          <td style="text-align: center">
            {{ applet.description }}
          </td>
          <td style="text-align: center">
            {{ applet.fileName }}
          </td>
          <td style="text-align: center">
            <ng-container *ngIf="!applet.deleted">
              <rs-status-icon
                *ngIf="applet.status === 'incomplete'"
                state="incomplete"
                i18n-tooltip
                tooltip="Applet eSim profile configuration is incomplete"
              />
              <rs-status-icon
                *ngIf="applet.status === 'complete'"
                state="complete"
                i18n-tooltip
                tooltip="Applet eSim profile configuration is complete"
              />
              <rs-status-icon
                *ngIf="applet.status === 'error'"
                state="error"
                i18n-tooltip
                tooltip="Applet eSim profile configuration contains errors"
              />
            </ng-container>
          </td>
          <td style="text-align: center">
            <ng-container *ngIf="!applet.deleted">
              <rs-status-icon
                *ngIf="applet.warehouseStatus === 'incomplete'"
                state="incomplete"
                i18n-tooltip
                tooltip="Applet Warehouse configuration is incomplete"
              />
              <rs-status-icon
                *ngIf="applet.warehouseStatus === 'complete'"
                state="complete"
                i18n-tooltip
                tooltip="Applet Warehouse configuration is complete"
              />
              <rs-status-icon
                *ngIf="applet.warehouseStatus === 'error'"
                state="error"
                i18n-tooltip
                tooltip="Applet Warehouse configuration contains errors"
              />
            </ng-container>
            <ng-container *ngIf="applet.deleted">
              <rs-status-icon
                *ngIf="applet.status === 'error'"
                state="error"
                i18n-tooltip
                tooltip="Applet has been deleted from warehouse and should be removed from profile"
              />
            </ng-container>
          </td>
          <td style="text-align: center">
            <ng-container *ngIf="!applet.deleted">
              <p-button
                icon="pi pi-pen-to-square"
                [rounded]="true"
                [text]="true"
                (onClick)="editApplet(applet.appletId)"
                i18n-pTooltip
                pTooltip="Edit applet configuration"
                tooltipPosition="left"
                i18n-ariaLabel
                ariaLabel="Edit applet configuration"
                [showDelay]="250"
              ></p-button>
            </ng-container>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="7" i18n>No Java Applets are included with this profile.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</ng-container>
<ng-container *ngIf="editAppletMode && editDedicatedFileMode && !editDedicatedFileId">
  <p class="font-bold line-height-2" i18n>Does this applet require dedicated file(s)?</p>
  <div class="ml-6 mb-3">
    <table style="border-collapse: separate; border-spacing: 0 20px">
      <tr>
        <td>
          <p-radioButton
            name="requiresDedicatedFile"
            inputId="requiresDedicatedFile#1"
            value="1"
            [ngModel]="applet.requiresDedicatedFile"
            (ngModelChange)="onRequiresDedicatedFileChange($event)"
          ></p-radioButton>
        </td>
        <td>
          <label class="ml-2 mr-6 label-clickable" for="requiresDedicatedFile#1" i18n>Yes</label>
        </td>
        <td>
          <p-radioButton
            name="requiresDedicatedFile"
            inputId="requiresDedicatedFile#0"
            value="0"
            [ngModel]="applet.requiresDedicatedFile"
            (ngModelChange)="onRequiresDedicatedFileChange($event)"
          ></p-radioButton>
        </td>
        <td>
          <label class="ml-2 mr-6 label-clickable" for="requiresDedicatedFile#0" i18n>No</label>
        </td>
      </tr>
    </table>
  </div>
  <ng-container *ngIf="+applet.requiresDedicatedFile === 1">
    <div class="mx-6">
      <p class="font-bold line-height-2" i18n>Please define the dedicated file(s).</p>
      <div class="mx-6 mb-3">
        <rs-error-message *ngIf="errorFoundForDedicatedFiles" class="mt-3 mb-3" [message]="errorMessageDedicatedFiles" />
        <p-table
          showGridlines="true"
          stripedRows="true"
          [value]="dedicatedFiles"
          [(selection)]="selectedDedicatedFiles"
          dataKey="id"
          sortField="id"
          [sortOrder]="1"
          styleClass="p-datatable-striped p-datatable-gridlines"
        >
          <ng-template pTemplate="caption">
            <div class="flex align-items-center gap-2">
              <p-button
                i18n-label
                label="Add"
                icon="pi pi-plus-circle"
                size="small"
                [outlined]="true"
                (onClick)="addDedicatedFile()"
              ></p-button>
              <p-button
                i18n-label
                label="Delete"
                icon="pi pi-trash"
                size="small"
                severity="danger"
                [outlined]="true"
                (onClick)="deleteDedicatedFiles()"
                [disabled]="!selectedDedicatedFiles || !selectedDedicatedFiles.length"
              ></p-button>
            </div>
          </ng-template>
          <ng-template pTemplate="colgroup">
            <colgroup>
              <col style="width: 3rem" />
              <col style="width: 5rem" />
              <col />
              <col />
              <col style="width: 5rem" />
              <col style="width: 5rem" />
            </colgroup>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th>
                <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
              </th>
              <th i18n>#</th>
              <th i18n>File Name</th>
              <th i18n>File ID</th>
              <th i18n>Status</th>
              <th i18n>Actions</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-file>
            <tr>
              <td style="text-align: center">
                <p-tableCheckbox [value]="file"></p-tableCheckbox>
              </td>
              <td style="text-align: center">
                {{ file.id }}
              </td>
              <td style="text-align: center">
                {{ file.fileName }}
              </td>
              <td style="text-align: center">
                {{ file.fileId }}
              </td>
              <td style="text-align: center">
                <rs-status-icon
                  *ngIf="file.status === 'incomplete'"
                  state="incomplete"
                  i18n-tooltip
                  tooltip="Dedicated file configuration is incomplete"
                />
                <rs-status-icon
                  *ngIf="file.status === 'complete'"
                  state="complete"
                  i18n-tooltip
                  tooltip="Dedicated file configuration is complete"
                />
                <rs-status-icon
                  *ngIf="file.status === 'error'"
                  state="error"
                  i18n-tooltip
                  tooltip="Dedicated file configuration contains errors"
                />
              </td>
              <td style="text-align: center">
                <p-button
                  icon="pi pi-pen-to-square"
                  [rounded]="true"
                  [text]="true"
                  (onClick)="editDedicatedFile(file.id)"
                  i18n-pTooltip
                  pTooltip="Edit dedicated file configuration"
                  tooltipPosition="left"
                  i18n-ariaLabel
                  ariaLabel="Edit dedicated file configuration"
                  [showDelay]="250"
                ></p-button>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="6" i18n>No dedicated files are associated to this applet.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </ng-container>
</ng-container>
<ng-container *ngIf="editAppletMode && editDedicatedFileMode && editDedicatedFileId">
  <div class="mx-6">
    <p class="font-bold" i18n>Please define the dedicated file.</p>
    <div class="mx-6 mb-3">
      <rs-error-message *ngIf="errorFoundForDedicatedFile" class="mt-3" [message]="errorMessageDedicatedFile" />
      <table style="border-collapse: separate; border-spacing: 0 20px">
        <tr>
          <td>
            <div class="font-bold mr-3" i18n>File Name:</div>
          </td>
          <td style="width: 20rem">
            <input
              class="maximize-inputs"
              type="text"
              pInputText
              rsAlphanumericOnlyInput
              [(ngModel)]="dedicatedFile.fileName"
              maxlength="20"
              (input)="handleFormEvents()"
            />
          </td>
          <td><div class="ml-3" i18n>(e.g., DualMSI)</div></td>
        </tr>
        <tr>
          <td>
            <div class="font-bold mr-3" i18n>File ID:</div>
          </td>
          <td>
            <input
              pInputText
              rsHexOnlyInput
              class="maximize-inputs console-text"
              [maxlength]="4"
              [(ngModel)]="dedicatedFile.fileId"
              (input)="handleFormEvents()"
            />
          </td>
          <td><div class="ml-3" i18n="@@fileIdMaxValueHint">(Max value is 2 HEX bytes)</div></td>
        </tr>
        <tr style="vertical-align: top">
          <td>
            <div class="font-bold mr-3" i18n>Access Rules:</div>
          </td>
          <td colspan="2">
            <table width="100%" cellspacing="0" cellpadding="5" border="1">
              <tr style="background: var(--rs-gray-200)">
                <th style="width: 7rem" i18n>Delete Self</th>
                <th style="width: 7rem" i18n>Terminate</th>
                <th style="width: 7rem" i18n>Activate</th>
                <th style="width: 7rem" i18n>Deactivate</th>
                <th style="width: 7rem" i18n>Create DF</th>
                <th style="width: 7rem" i18n>Create EF</th>
              </tr>
              <tr>
                <td>
                  <p-select
                    styleClass="maximize-inputs"
                    [options]="accessRuleOptions"
                    [(ngModel)]="dedicatedFile.accessRules.deleteSelf"
                    dataKey="value"
                    optionLabel="label"
                    i18n-placeholder
                    placeholder="Please Select:"
                    appendTo="body"
                    (onChange)="handleFormEvents()"
                  ></p-select>
                </td>
                <td>
                  <p-select
                    styleClass="maximize-inputs"
                    [options]="accessRuleOptions"
                    [(ngModel)]="dedicatedFile.accessRules.terminate"
                    dataKey="value"
                    optionLabel="label"
                    i18n-placeholder
                    placeholder="Please Select:"
                    appendTo="body"
                    (onChange)="handleFormEvents()"
                  ></p-select>
                </td>
                <td>
                  <p-select
                    styleClass="maximize-inputs"
                    [options]="accessRuleOptions"
                    [(ngModel)]="dedicatedFile.accessRules.activate"
                    dataKey="value"
                    optionLabel="label"
                    i18n-placeholder
                    placeholder="Please Select:"
                    appendTo="body"
                    (onChange)="handleFormEvents()"
                  ></p-select>
                </td>
                <td>
                  <p-select
                    styleClass="maximize-inputs"
                    [options]="accessRuleOptions"
                    [(ngModel)]="dedicatedFile.accessRules.deactivate"
                    dataKey="value"
                    optionLabel="label"
                    i18n-placeholder
                    placeholder="Please Select:"
                    appendTo="body"
                    (onChange)="handleFormEvents()"
                  ></p-select>
                </td>
                <td>
                  <p-select
                    styleClass="maximize-inputs"
                    [options]="accessRuleOptions"
                    [(ngModel)]="dedicatedFile.accessRules.createDF"
                    dataKey="value"
                    optionLabel="label"
                    i18n-placeholder
                    placeholder="Please Select:"
                    appendTo="body"
                    (onChange)="handleFormEvents()"
                  ></p-select>
                </td>
                <td>
                  <p-select
                    styleClass="maximize-inputs"
                    [options]="accessRuleOptions"
                    [(ngModel)]="dedicatedFile.accessRules.createEF"
                    dataKey="value"
                    optionLabel="label"
                    i18n-placeholder
                    placeholder="Please Select:"
                    appendTo="body"
                    (onChange)="handleFormEvents()"
                  ></p-select>
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <td>
            <div class="font-bold mr-3" i18n>PIN Status:</div>
          </td>
          <td colspan="2">
            <table>
              <tr>
                <td>
                  <p-checkbox [(ngModel)]="dedicatedFile.pinStatus.pin1" [binary]="true"></p-checkbox>
                </td>
                <td><div class="ml-2 mr-3">PIN1</div></td>
                <td>
                  <p-checkbox [(ngModel)]="dedicatedFile.pinStatus.adm1" [binary]="true"></p-checkbox>
                </td>
                <td><div class="ml-2 mr-3">ADM</div></td>
                <td>
                  <p-checkbox [(ngModel)]="dedicatedFile.pinStatus.pin2" [binary]="true"></p-checkbox>
                </td>
                <td><div class="ml-2 mr-3">PIN2</div></td>
                <td><div class="ml-2" i18n>(Default PIN1 & ADM1)</div></td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <td>
            <div class="font-bold mr-3" i18n>Location of DF:</div>
          </td>
          <td>
            <p-select
              styleClass="maximize-inputs"
              [options]="locationOfFileOptions"
              [(ngModel)]="dedicatedFile.locationOfFile"
              dataKey="value"
              optionLabel="label"
              i18n-placeholder
              placeholder="Please Select:"
              appendTo="body"
              (onChange)="handleFormEvents()"
            ></p-select>
          </td>
          <td></td>
        </tr>
        <tr *ngIf="+dedicatedFile.locationOfFile.value === 4">
          <td></td>
          <td>
            <p-select
              styleClass="maximize-inputs"
              [options]="dedicatedFileLocationOptions"
              [(ngModel)]="dedicatedFile.locatedInDF"
              dataKey="value"
              optionLabel="label"
              i18n-placeholder
              placeholder="Please Select:"
              appendTo="body"
              (onChange)="handleFormEvents()"
            ></p-select>
          </td>
          <td><div class="ml-2" i18n>(Select a DF to locate this file within)</div></td>
        </tr>
      </table>
    </div>
  </div>
</ng-container>
<ng-container *ngIf="editAppletMode && editElementaryFileMode && !editElementaryFileId">
  <div class="font-bold mb-3" i18n>Does this applet require elementary file(s)?</div>
  <div class="ml-6 mb-3">
    <table style="border-collapse: separate; border-spacing: 0 20px">
      <tr>
        <td>
          <p-radioButton
            name="requiresElementaryFile"
            inputId="requiresElementaryFile#1"
            value="1"
            [ngModel]="applet.requiresElementaryFile"
            (ngModelChange)="onRequiresElementaryFileChange($event)"
          ></p-radioButton>
        </td>
        <td>
          <label class="ml-2 mr-6 label-clickable" for="requiresElementaryFile#1" i18n>Yes</label>
        </td>
        <td>
          <p-radioButton
            name="requiresElementaryFile"
            inputId="requiresElementaryFile#0"
            value="0"
            [ngModel]="applet.requiresElementaryFile"
            (ngModelChange)="onRequiresElementaryFileChange($event)"
          ></p-radioButton>
        </td>
        <td>
          <label class="ml-2 mr-6 label-clickable" for="requiresElementaryFile#0" i18n>No</label>
        </td>
      </tr>
    </table>
  </div>
  <ng-container *ngIf="+applet.requiresElementaryFile === 1">
    <div class="mx-6">
      <p class="font-bold" i18n>Please define the elementary file(s).</p>
      <div class="mx-6 mb-3">
        <rs-error-message *ngIf="errorFoundForElementaryFiles" class="mt-3 mb-3" [message]="errorMessageElementaryFiles" />
        <p-table
          showGridlines="true"
          stripedRows="true"
          [value]="elementaryFiles"
          [(selection)]="selectedElementaryFiles"
          dataKey="id"
          sortField="id"
          [sortOrder]="1"
          styleClass="p-datatable-striped p-datatable-gridlines"
        >
          <ng-template pTemplate="caption">
            <div class="flex align-items-center">
              <p-button
                i18n-label
                label="Add"
                icon="pi pi-plus-circle"
                size="small"
                [outlined]="true"
                styleClass="mr-2"
                (onClick)="addElementaryFile()"
              ></p-button>
              <p-button
                i18n-label
                label="Delete"
                icon="pi pi-trash"
                size="small"
                severity="danger"
                [outlined]="true"
                styleClass="mr-2"
                (onClick)="deleteElementaryFiles()"
                [disabled]="!selectedElementaryFiles || !selectedElementaryFiles.length"
              ></p-button>
            </div>
          </ng-template>
          <ng-template pTemplate="colgroup">
            <colgroup>
              <col style="width: 3rem" />
              <col style="width: 5rem" />
              <col />
              <col />
              <col style="width: 5rem" />
              <col style="width: 5rem" />
            </colgroup>
          </ng-template>
          <ng-template pTemplate="header">
            <tr>
              <th>
                <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
              </th>
              <th i18n>#</th>
              <th i18n>File Name</th>
              <th i18n>File ID</th>
              <th i18n>Status</th>
              <th i18n>Actions</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-file>
            <tr>
              <td style="text-align: center">
                <p-tableCheckbox [value]="file"></p-tableCheckbox>
              </td>
              <td style="text-align: center">
                {{ file.id }}
              </td>
              <td style="text-align: center">
                {{ file.fileName }}
              </td>
              <td style="text-align: center">
                {{ file.fileId }}
              </td>
              <td style="text-align: center">
                <rs-status-icon
                  *ngIf="file.status === 'incomplete'"
                  state="incomplete"
                  i18n-tooltip
                  tooltip="Elementary file configuration is incomplete"
                />
                <rs-status-icon
                  *ngIf="file.status === 'complete'"
                  state="complete"
                  i18n-tooltip
                  tooltip="Elementary file configuration is complete"
                />
                <rs-status-icon
                  *ngIf="file.status === 'error'"
                  state="error"
                  i18n-tooltip
                  tooltip="Elementary file configuration contains errors"
                />
              </td>
              <td style="text-align: center">
                <p-button
                  icon="pi pi-pen-to-square"
                  [rounded]="true"
                  [text]="true"
                  (onClick)="editElementaryFile(file.id)"
                  i18n-pTooltip
                  pTooltip="Edit elementary file configuration"
                  tooltipPosition="left"
                  i18n-ariaLabel
                  ariaLabel="Edit elementary file configuration"
                  [showDelay]="250"
                ></p-button>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="6" i18n>No elementary files are associated to this applet.</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </ng-container>
</ng-container>
<ng-container *ngIf="editAppletMode && editElementaryFileMode && editElementaryFileId">
  <div class="mx-6">
    <div class="font-bold mb-3" i18n>Please define the elementary file.</div>
    <div class="mx-6 mb-3">
      <rs-error-message *ngIf="errorFoundForElementaryFile" class="mt-6 mb-3" [message]="errorMessageElementaryFile" />
      <table style="border-collapse: separate; border-spacing: 0 20px">
        <tr>
          <td>
            <div class="font-bold mr-3" i18n>File Name:</div>
          </td>
          <td style="width: 20rem">
            <input
              class="maximize-inputs"
              type="text"
              pInputText
              rsAlphanumericOnlyInput
              [(ngModel)]="elementaryFile.fileName"
              maxlength="20"
              (input)="handleFormEvents()"
            />
          </td>
          <td><div class="ml-3" i18n>(e.g., DualMSI)</div></td>
        </tr>
        <tr>
          <td>
            <div class="font-bold mr-3" i18n>File ID:</div>
          </td>
          <td>
            <input
              pInputText
              rsHexOnlyInput
              class="maximize-inputs console-text"
              [maxlength]="4"
              [(ngModel)]="elementaryFile.fileId"
              (input)="handleFormEvents()"
            />
          </td>
          <td><div class="ml-3" i18n="@@fileIdMaxValueHint">(Max value is 2 HEX bytes)</div></td>
        </tr>
        <tr>
          <td>
            <div class="font-bold mr-3" i18n>File Structure:</div>
          </td>
          <td colspan="2">
            <table>
              <tr>
                <td>
                  <p-radioButton
                    (onClick)="setRecordLengthMinMaxThresholds()"
                    name="fileStructure"
                    inputId="fileStructure#1"
                    value="1"
                    [(ngModel)]="elementaryFile.fileStructure"
                  ></p-radioButton>
                </td>
                <td>
                  <label class="ml-2 mr-6 label-clickable" for="fileStructure#1" i18n>Transparent</label>
                </td>
                <td>
                  <p-radioButton
                    (onClick)="setRecordLengthMinMaxThresholds()"
                    name="fileStructure"
                    inputId="fileStructure#2"
                    value="2"
                    [(ngModel)]="elementaryFile.fileStructure"
                  ></p-radioButton>
                </td>
                <td>
                  <label class="ml-2 mr-6 label-clickable" for="fileStructure#2" i18n>Linear Fixed</label>
                </td>
                <td>
                  <p-radioButton
                    (onClick)="setRecordLengthMinMaxThresholds()"
                    name="fileStructure"
                    inputId="fileStructure#3"
                    value="3"
                    [(ngModel)]="elementaryFile.fileStructure"
                  ></p-radioButton>
                </td>
                <td>
                  <label class="ml-2 mr-6 label-clickable" for="fileStructure#3" i18n>Cyclic</label>
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <td>
            <div class="font-bold mr-3" i18n>File Size:</div>
          </td>
          <td>
            <input
              class="maximize-inputs console-text"
              type="text"
              pInputText
              inputmode="text"
              [maxlength]="fileSizeMax.toString(16).length"
              [ngModel]="elementaryFileSizeHex"
              (ngModelChange)="onElementaryFileSizeHexChange($event)"
              i18n-aria-label
              aria-label="File Size in hexadecimal"
            />
          </td>
          <td><div class="ml-3" i18n>(Total bytes for the file size, value in Hexadecimal)</div></td>
        </tr>
        <tr *ngIf="+elementaryFile.fileStructure === 2 || +elementaryFile.fileStructure === 3">
          <td>
            <div class="font-bold mr-3" i18n>Record Length:</div>
          </td>
          <td>
            <input
              class="maximize-inputs console-text"
              type="text"
              pInputText
              inputmode="text"
              [maxlength]="recordLengthMax.toString(16).length"
              [ngModel]="elementaryFileRecordLengthHex"
              (ngModelChange)="onElementaryFileRecordLengthHexChange($event)"
              i18n-aria-label
              aria-label="Record Length in hexadecimal"
            />
          </td>
          <td><div class="ml-3" i18n>(Number of bytes per record within the file, value in Hexadecimal)</div></td>
        </tr>
        <tr style="vertical-align: top">
          <td>
            <div class="font-bold mr-3">
              <div style="display: inline; position: relative; top: -10px">Access Rules:</div>
              <div style="display: inline">
                <p-button
                  icon="pi pi-external-link"
                  [rounded]="true"
                  [text]="true"
                  (onClick)="showAccessRuleHelp = true"
                  i18n-pTooltip
                  pTooltip="Access rule preset picker"
                  tooltipPosition="top"
                  i18n-ariaLabel
                  ariaLabel="Access rule preset picker"
                  [showDelay]="250"
                ></p-button>
              </div>
            </div>
          </td>
          <td colspan="2">
            <table width="100%" cellspacing="0" cellpadding="5" border="1">
              <tr style="background: var(--rs-gray-200)">
                <th style="width: 7rem" i18n>Access Rules</th>
                <th style="width: 7rem" i18n>Read</th>
                <th style="width: 7rem" i18n>Update</th>
                <th style="width: 7rem" i18n>Increase</th>
                <th style="width: 7rem" i18n>Activate</th>
                <th style="width: 7rem" i18n>Deactivate</th>
                <th style="width: 7rem" i18n>Delete</th>
              </tr>
              <tr>
                <td>
                  <p-select
                    styleClass="maximize-inputs"
                    [options]="accessRulePresets"
                    [(ngModel)]="elementaryFile.accessRules.ruleNumber"
                    dataKey="value"
                    optionLabel="label"
                    i18n-placeholder
                    placeholder="Please Select:"
                    appendTo="body"
                    (onChange)="updateAccessRulePreset()"
                  ></p-select>
                </td>
                <td>
                  <p-select
                    styleClass="maximize-inputs"
                    [options]="accessRuleOptionsEF"
                    [(ngModel)]="elementaryFile.accessRules.read"
                    dataKey="value"
                    optionLabel="label"
                    i18n-placeholder
                    placeholder="Please Select:"
                    appendTo="body"
                    (onChange)="handleFormEvents()"
                    [disabled]="true"
                  ></p-select>
                </td>
                <td>
                  <p-select
                    styleClass="maximize-inputs"
                    [options]="accessRuleOptionsEF"
                    [(ngModel)]="elementaryFile.accessRules.update"
                    dataKey="value"
                    optionLabel="label"
                    i18n-placeholder
                    placeholder="Please Select:"
                    appendTo="body"
                    (onChange)="handleFormEvents()"
                    [disabled]="true"
                  ></p-select>
                </td>
                <td>
                  <p-select
                    styleClass="maximize-inputs"
                    [options]="accessRuleOptionsEF"
                    [(ngModel)]="elementaryFile.accessRules.increase"
                    dataKey="value"
                    optionLabel="label"
                    i18n-placeholder
                    placeholder="Please Select:"
                    appendTo="body"
                    (onChange)="handleFormEvents()"
                    [disabled]="true"
                  ></p-select>
                </td>
                <td>
                  <p-select
                    styleClass="maximize-inputs"
                    [options]="accessRuleOptionsEF"
                    [(ngModel)]="elementaryFile.accessRules.activate"
                    dataKey="value"
                    optionLabel="label"
                    i18n-placeholder
                    placeholder="Please Select:"
                    appendTo="body"
                    (onChange)="handleFormEvents()"
                    [disabled]="true"
                  ></p-select>
                </td>
                <td>
                  <p-select
                    styleClass="maximize-inputs"
                    [options]="accessRuleOptionsEF"
                    [(ngModel)]="elementaryFile.accessRules.deactivate"
                    dataKey="value"
                    optionLabel="label"
                    i18n-placeholder
                    placeholder="Please Select:"
                    appendTo="body"
                    (onChange)="handleFormEvents()"
                    [disabled]="true"
                  ></p-select>
                </td>
                <td>
                  <p-select
                    styleClass="maximize-inputs"
                    [options]="accessRuleOptionsEF"
                    [(ngModel)]="elementaryFile.accessRules.delete"
                    dataKey="value"
                    optionLabel="label"
                    i18n-placeholder
                    placeholder="Please Select:"
                    appendTo="body"
                    (onChange)="handleFormEvents()"
                    [disabled]="true"
                  ></p-select>
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <td>
            <div class="font-bold mr-3" i18n>High Update Activity:</div>
          </td>
          <td colspan="2">
            <table>
              <tr>
                <td>
                  <p-radioButton
                    (onClick)="handleFormEvents()"
                    name="highUpdateActivity"
                    inputId="highUpdateActivity#1"
                    value="1"
                    [(ngModel)]="elementaryFile.highUpdateActivity"
                  ></p-radioButton>
                </td>
                <td>
                  <label class="ml-2 mr-6 label-clickable" for="highUpdateActivity#1" i18n>Yes</label>
                </td>
                <td>
                  <p-radioButton
                    (onClick)="handleFormEvents()"
                    name="highUpdateActivity"
                    inputId="highUpdateActivity#2"
                    value="2"
                    [(ngModel)]="elementaryFile.highUpdateActivity"
                  ></p-radioButton>
                </td>
                <td>
                  <label class="ml-2 mr-6 label-clickable" for="highUpdateActivity#2" i18n>No</label>
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <tr>
          <td>
            <div class="font-bold mr-3" i18n>Location of EF:</div>
          </td>
          <td>
            <p-select
              styleClass="maximize-inputs"
              [options]="locationOfFileOptions"
              [(ngModel)]="elementaryFile.locationOfFile"
              dataKey="value"
              optionLabel="label"
              i18n-placeholder
              placeholder="Please Select:"
              appendTo="body"
              (onChange)="handleFormEvents()"
            ></p-select>
          </td>
          <td></td>
        </tr>
        <tr *ngIf="+elementaryFile.locationOfFile.value === 4">
          <td></td>
          <td>
            <p-select
              styleClass="maximize-inputs"
              [options]="dedicatedFileLocationOptions"
              [(ngModel)]="elementaryFile.locatedInDF"
              dataKey="value"
              optionLabel="label"
              i18n-placeholder
              placeholder="Please Select:"
              appendTo="body"
              (onChange)="handleFormEvents()"
            ></p-select>
          </td>
          <td><div class="ml-2" i18n>(Select a DF to locate this file within)</div></td>
        </tr>
        <tr style="vertical-align: top" *ngIf="elementaryFile.fileContent.length > 0">
          <td>
            <div class="font-bold mr-3 pt-2" i18n>File Content:</div>
          </td>
          <td colspan="2">
            <p-table
              showGridlines="true"
              stripedRows="true"
              [value]="elementaryFile.fileContent"
              [loading]="false"
              [resizableColumns]="false"
              [rows]="10"
              [showCurrentPageReport]="true"
              [rowsPerPageOptions]="[10, 25, 50, 100]"
              [paginator]="true"
              [alwaysShowPaginator]="true"
              currentPageReportTemplate="{first} - {last} / {totalRecords}"
            >
              <ng-template pTemplate="colgroup">
                <colgroup>
                  <col style="width: 4rem" />
                  <col />
                </colgroup>
              </ng-template>
              <ng-template pTemplate="body" let-file let-index="rowIndex">
                <tr>
                  <td>{{ index + 1 }}</td>
                  <td>
                    <input
                      [(ngModel)]="file.content"
                      class="maximize-inputs"
                      type="text"
                      [maxlength]="elementaryFile.recordLength * 2"
                      pInputText
                      rsHexOnlyInput
                      (change)="handleFormEvents()"
                    />
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="2"><span i18n>No file content.</span></td>
                </tr>
              </ng-template>
            </p-table>
          </td>
        </tr>
      </table>
    </div>
  </div>
</ng-container>

<ng-template #applyAccessRulePresetButtonTemplate let-preset="preset">
  <p-button
    i18n-pTooltip
    pTooltip="Apply access rule preset"
    tooltipPosition="left"
    i18n-ariaLabel
    ariaLabel="Apply access rule preset"
    [showDelay]="250"
    [label]="preset"
    variant="text"
    styleClass="preset-button"
    (onClick)="setAccessRulePreset(preset)"
  ></p-button>
</ng-template>
